import React, { Component } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Label,
  Modal,
  Row,
  CardBody,
  ModalHeader,
  ModalBody,
  Spinner,
  CardTitle,
  Input,
} from "reactstrap";
import MetaTags from "react-meta-tags";
import API from "../../helpers/api_helper";
import * as Yup from "yup";
import toastr from "toastr";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { Formik, Field, Form, ErrorMessage } from "formik";
import BootstrapTable from "react-bootstrap-table-next";
import { Constants } from "helpers/constants";
import { Link } from "react-router-dom";
import DeleteModal from "components/Common/DeleteModal";
import Dropzone from "react-dropzone";

class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      videos: null,
      loading: true,
      subLoading: false,
      modal: false,
      formValue: {
        title: "",
        description: "",
        type: "",
      },
      isEdit: false,
      selectedUser: null,
      deleteModal: false,
      selectedFiles: [],
      selectedVidFiles: [],
      subLoading: false,
      videoSrc: null,
    };
  }
  componentDidMount() {
    this.didMount();
  }

  didMount = async () => {
    this.setState({ loading: true });
    try {
      const res = await API.slider.list();
      console.log("RES IS : ", res);
      if (res.status) {
        this.setState({
          loading: false,
          users: res.slider,
          videos: res.video,
          videoSrc: res.video[0].file,
        });
        document.getElementById("vid_title").value = res.video[0].title;
      } else {
        throw res;
      }
    } catch (error) {
      console.log("ERROR CODE 3 : ", error);
    }
  };

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  };

  handleSubmitAddForm = async values => {
    const { selectedUser, isEdit, selectedFiles } = this.state;
    console.log("SELECTED FIREL LENGTH ", selectedFiles);
    console.log("SELECTED FIREL LENGTH ", selectedFiles[0]);
    this.setState({ subLoading: true });
    let formData = new FormData();
    const keys = Object.keys(values);

    keys.forEach(item => {
      formData.append(item, values[item]);
    });

    if (isEdit) {
      formData.append("slider_id", selectedUser.id);
      if (!!selectedFiles.length) {
        selectedFiles.forEach(item => {
          formData.append("images", item, item.name);
        });
      }
      try {
        const res = await API.slider.edit(formData);
        console.log("RES IS : ", res);
        if (res.status) {
          toastr.success("اسلایدر  با موفقیت ویرایش شد", "موفق");
          this.setState({
            subLoading: false,
            modal: false,
            isEdit: false,
            selectedUser: null,
          });
          this.didMount();
        } else {
          throw res;
        }
      } catch (error) {
        this.setState({ subLoading: false });
        console.log("ERROR CODE 5 : ", error);
      }
    } else {
      if (!!selectedFiles.length) {
        selectedFiles.forEach(item => {
          formData.append("images", item, item.name);
        });
        try {
          const res = await API.slider.add(formData);
          console.log("RES IS : ", res);
          if (res.status) {
            toastr.success("اسلایدر با موفقیت اضافه شد", "موفق");
            this.setState({ subLoading: false, modal: false });
            this.didMount();
          } else {
            throw res;
          }
        } catch (error) {
          this.setState({ subLoading: false });
          console.log("ERROR CODE 4 : ", error);
        }
      } else {
        this.setState({ subLoading: false });
        toastr.warning("انتخاب تصویر اشتراک اجباری است.", "اخطار");
      }
    }
  };

  handleUserClick = arg => {
    const { title, description, type } = arg;

    this.setState({
      formValue: {
        title,
        description,
        type,
      },
      isEdit: true,
      selectedUser: arg,
    });

    this.toggle();
  };

  handleDeleteUser = async () => {
    const { selectedUser } = this.state;
    console.log("SELECTED : ", selectedUser);
    try {
      const { status } = await API.slider.delete(selectedUser.id);
      if (status) {
        toastr.success("اسلایدر با موفقیت حذف شد", "موفق");
        this.setState({ selectedUser: null, deleteModal: false });
        this.didMount();
      } else {
        throw status;
      }
    } catch (error) {
      console.log("ERROR CODE 128 : ", error);
    }
  };

  handleOpenDeleteModal = user => {
    this.setState({ deleteModal: true, selectedUser: user });
  };

  handleAcceptedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    );

    this.setState({ selectedFiles: files });
  };

  handleAcceptedVidFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    );

    this.setState({ selectedVidFiles: files });
  };

  handleSubmitVid = async () => {
    const { subLoading, selectedVidFiles } = this.state;
    const titleValue = document.getElementById("vid_title").value;
    if (!!selectedVidFiles.length && !!titleValue) {
      let formData = new FormData();

      formData.append("title", titleValue);

      formData.append("id", 1);
      formData.append("file", selectedVidFiles[0], selectedVidFiles[0].name);

      try {
        const res = await API.slider.editVideo(formData);
        if (res.status) {
          toastr.success(res.message, "موفق");
          this.didMount();
        } else {
          throw res;
        }
      } catch (error) {
        console.log("Error : ", error);
      }

      this.setState({ subLoading: false });
    } else {
      toastr.error("وارد کردن عنون و ویدئو اجباری است", "خطا");
    }
  };

  /**
   * Formats the size
   */
  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  render() {
    const { SearchBar } = Search;

    const {
      users,
      loading,
      modal,
      isEdit,
      subLoading,
      formValue,
      deleteModal,
    } = this.state;

    const pageOptions = {
      sizePerPage: 10,
      // totalSize: users.length, // replace later with size(users),
      totalSize: 1, // replace later with size(users),
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: "id", // if dataField is not match to any column you defined, it will be ignored.
        order: "desc", // desc or asc
      },
    ];

    const selectRow = {
      mode: "checkbox",
    };

    const columns = [
      {
        text: "id",
        dataField: "id",
        sort: true,
        hidden: true,
        formatter: (cellContent, user) => <>{user.id}</>,
      },
      {
        text: "عنوان بسته",
        dataField: "title",
        sort: true,
        formatter: (cellContent, user) => (
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {user.title}
            </Link>
          </h5>
        ),
      },
      {
        text: "تصویر",
        dataField: "images",
        formatter: (cellContent, user) => (
          <img
            src={Constants.imageUrl + user.images}
            width={50}
            alt="icon"
            className="rounded me-2 onHoverBig"
          />
        ),
      },
      {
        dataField: "description",
        text: "توضیحات",
        sort: true,
      },
      {
        dataField: "type",
        text: "مکان قرارگیری در سایت",
        sort: true,
        formatter : (val) =>{
          if(val === "main") return "صفحه اصلی"
          if(val === "product") return "صفحه محصولات"
          if(val === "aboutUs") return "درباره ما"
          if(val === "catalog") return "کاتالوگ"
          if(val === "contactUs") return "تماس با ما"
          return val
        }
      },
      {
        dataField: "menu",
        isDummyField: true,
        editable: false,
        text: "Action",
        formatter: (cellContent, user) => (
          <div className="d-flex gap-3">
            <Link className="text-success" to="#">
              <i
                className="mdi mdi-pencil font-size-18"
                id="edittooltip"
                onClick={() => this.handleUserClick(user)}
              ></i>
            </Link>

            <Link className="text-danger" to="#">
              <i
                className="bx bx-trash font-size-18 mt-1"
                id="edittooltip"
                onClick={() => this.handleOpenDeleteModal(user)}
              ></i>
            </Link>
          </div>
        ),
      },
    ];

    return (
      <React.Fragment>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteUser}
          onCloseClick={() =>
            this.setState({ deleteModal: false, selectedUser: null })
          }
        />
        <div className="page-content">
          <MetaTags>
            <title>خانه من | مدیریت اسلایدر ها</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="خانه من" breadcrumbItem="مدیریت اسلایدر ها" />
          </Container>

          <Row>
            <Col lg="12" className="mb-2">
              <Card>
                <CardBody>
                  {loading ? (
                    <Spinner size="lg" />
                  ) : (
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={columns}
                      data={users}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={columns}
                          data={users}
                          search
                        >
                          {toolkitprops => (
                            <React.Fragment>
                              <Row className="mb-2">
                                <Col sm="4">
                                  <div className="search-box ms-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitprops.searchProps}
                                        placeholder="جستجو"
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                                <Col sm="8">
                                  <div className="text-sm-end">
                                    <Button
                                      color="primary"
                                      className="font-16 btn-block btn btn-primary bg-gold"
                                      onClick={this.toggle}
                                    >
                                      <i className="mdi mdi-plus-circle-outline me-1" />
                                      ایجاد اسلایدر جدید
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      selectRow={selectRow}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap table-hover"
                                      }
                                      bordered={false}
                                      striped={false}
                                      responsive
                                      ref={this.node}
                                    />

                                    <Modal
                                      isOpen={modal}
                                      onClosed={() =>
                                        this.setState({
                                          formValue: {
                                            title: "",
                                            description: "",
                                            type: "",
                                          },
                                        })
                                      }
                                    >
                                      <ModalHeader
                                        toggle={this.toggle}
                                        tag="h4"
                                      >
                                        {!!isEdit
                                          ? "ویرایش بسته"
                                          : "اضافه کردن بسته"}
                                      </ModalHeader>
                                      <ModalBody>
                                        <Formik
                                          enableReinitialize={true}
                                          initialValues={formValue}
                                          validationSchema={Yup.object().shape({
                                            title:
                                              Yup.string().required("اجباری"),
                                            description:
                                              Yup.string().required("اجباری"),
                                            type: Yup.string().required(
                                              "اجباری"
                                            ),
                                          })}
                                          onSubmit={this.handleSubmitAddForm}
                                        >
                                          {({ errors, status, touched }) => (
                                            <Form>
                                              <Row>
                                                <Col className="col-12">
                                                  <Dropzone
                                                    onDrop={acceptedFiles =>
                                                      this.handleAcceptedFiles(
                                                        acceptedFiles
                                                      )
                                                    }
                                                    multiple={false}
                                                  >
                                                    {({
                                                      getRootProps,
                                                      getInputProps,
                                                    }) => (
                                                      <div className="dropzone">
                                                        <div
                                                          className="dz-message needsclick"
                                                          {...getRootProps()}
                                                        >
                                                          <input
                                                            {...getInputProps()}
                                                          />
                                                          <div className="mb-3">
                                                            <i className="display-4 text-muted bx bxs-cloud-upload" />
                                                          </div>
                                                          <h4>
                                                            برای انتخاب عکس کلیک
                                                            کنید یا بکشید
                                                          </h4>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </Dropzone>
                                                  <div
                                                    className="dropzone-previews mt-3"
                                                    id="file-previews"
                                                  >
                                                    {this.state.selectedFiles.map(
                                                      (f, i) => {
                                                        return (
                                                          <Card
                                                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                            key={i + "-file"}
                                                          >
                                                            <div className="p-2">
                                                              <Row className="align-items-center">
                                                                <Col className="col-auto">
                                                                  <img
                                                                    data-dz-thumbnail=""
                                                                    height="80"
                                                                    className="avatar-sm rounded bg-light"
                                                                    alt={f.name}
                                                                    src={
                                                                      f.preview
                                                                    }
                                                                  />
                                                                </Col>
                                                                <Col>
                                                                  <Link
                                                                    to="#"
                                                                    className="text-muted font-weight-bold"
                                                                  >
                                                                    {f.name}
                                                                  </Link>
                                                                  <p className="mb-0">
                                                                    <strong>
                                                                      {
                                                                        f.formattedSize
                                                                      }
                                                                    </strong>
                                                                  </p>
                                                                </Col>
                                                              </Row>
                                                            </div>
                                                          </Card>
                                                        );
                                                      }
                                                    )}
                                                  </div>
                                                </Col>
                                                <Col className="col-12">
                                                  <div className="mb-3">
                                                    <Label className="form-label">
                                                      عنوان
                                                    </Label>
                                                    <Field
                                                      name="title"
                                                      type="text"
                                                      className={
                                                        "form-control" +
                                                        (errors.title &&
                                                        touched.title
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="title"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                  <div className="mb-3">
                                                    <Label className="form-label">
                                                      توضیحات
                                                    </Label>
                                                    <Field
                                                      name="description"
                                                      type="text"
                                                      as="textarea"
                                                      rows={5}
                                                      className={
                                                        "form-control" +
                                                        (errors.description &&
                                                        touched.description
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="description"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                  <div className="mb-3">
                                                    <Label className="form-label">
                                                      نوع اسلایدر
                                                    </Label>
                                                    <Field
                                                      name="type"
                                                      type="text"
                                                      as="select"
                                                      className={
                                                        "form-control" +
                                                        (errors.type &&
                                                        touched.type
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                    >
                                                      <option value="main">
                                                        صفحه اصلی
                                                      </option>
                                                      <option value="product">
                                                        محصولات
                                                      </option>
                                                      <option value="aboutUs">
                                                        درباره ما
                                                      </option>
                                                      <option value="catalog">
                                                        کاتالوگ
                                                      </option>
                                                      <option value="contactUs ">
                                                        تماس با ما
                                                      </option>
                                                    </Field>
                                                    <ErrorMessage
                                                      name="type"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col>
                                                  {subLoading ? (
                                                    <div className="text-end">
                                                      <button
                                                        type="button"
                                                        className="btn btn-success save-user bg-gold"
                                                        style={{
                                                          minWidth: "100px",
                                                        }}
                                                      >
                                                        <i className="bx bx-loader bx-spin font-size-16 align-middle" />{" "}
                                                        درحال ثبت
                                                      </button>
                                                    </div>
                                                  ) : (
                                                    <div className="text-end">
                                                      <button
                                                        type="submit"
                                                        className="btn btn-success save-user bg-gold"
                                                        style={{
                                                          minWidth: "100px",
                                                        }}
                                                      >
                                                        ذخیره
                                                      </button>
                                                    </div>
                                                  )}
                                                </Col>
                                              </Row>
                                            </Form>
                                          )}
                                        </Formik>
                                      </ModalBody>
                                    </Modal>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  )}
                </CardBody>
              </Card>
            </Col>

            <Col>
              <Card>
                <CardBody>
                  <CardTitle>مدیریت ویدئو صفحه اصلی</CardTitle>
                  <Row>
                    <Col xs={6}>
                      <video
                        src={Constants.imageUrl + this.state.videoSrc}
                        width="100%"
                        height="330px"
                        style={{ objectFit: "cover" }}
                        controls
                        className="mt-3"
                      />
                    </Col>
                    <Col xs={6}>
                      <Row>
                        <Col xs={12}>
                          <Label className="form-label">عنوان ویدئو</Label>
                          <Input
                            name="title"
                            id="vid_title"
                            placeholder="عنوان ویدئو"
                            className="form-control mb-3"
                          />
                        </Col>
                        <Col xs={12}>
                          <Dropzone
                            onDrop={acceptedFiles =>
                              this.handleAcceptedVidFiles(acceptedFiles)
                            }
                            multiple={false}
                          >
                            {({ getRootProps, getInputProps }) => (
                              <div className="dropzone">
                                <div
                                  className="dz-message needsclick"
                                  {...getRootProps()}
                                >
                                  <input {...getInputProps()} />
                                  <div className="mb-3">
                                    <i className="display-4 text-muted bx bxs-cloud-upload" />
                                  </div>
                                  <h4>برای انتخاب ویدئو کلیک کنید یا بکشید</h4>
                                </div>
                              </div>
                            )}
                          </Dropzone>
                          <div
                            className="dropzone-previews mt-3"
                            id="file-previews"
                          >
                            {this.state.selectedVidFiles.map((f, i) => {
                              return (
                                <Card
                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                  key={i + "-file"}
                                >
                                  <div className="p-2">
                                    <Row className="align-items-center">
                                      <Col className="col-auto">
                                        <img
                                          data-dz-thumbnail=""
                                          height="80"
                                          className="avatar-sm rounded bg-light"
                                          alt={f.name}
                                          src={f.preview}
                                        />
                                      </Col>
                                      <Col>
                                        <Link
                                          to="#"
                                          className="text-muted font-weight-bold"
                                        >
                                          {f.name}
                                        </Link>
                                        <p className="mb-0">
                                          <strong>{f.formattedSize}</strong>
                                        </p>
                                      </Col>
                                    </Row>
                                  </div>
                                </Card>
                              );
                            })}
                          </div>
                          <div className="d-flex justify-content-end">
                            <Button
                              onClick={this.handleSubmitVid}
                              disabled={this.state.subLoading}
                              style={{
                                paddingRight: "35px",
                                paddingLeft: "35px",
                              }}
                              color="primary"
                            >
                              ارسال محتوا
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default Slider;
